module.exports = __webpack_public_path__ + "img/101.6bf3235c.png";